import { jwtDecode } from 'jwt-decode'

import { ApiClient } from '../common/api/apiClient'

interface IToken {
  name: string
}

export const getColleagueName = (email: string | null | undefined) => {
  if (!email) {
    return {
      fullName: '',
      initials: '',
    }
  }

  const name = email.split('@')[0]
  const parts = name.split('.')
  const firstname = parts[0]
  const surname = parts.length > 1 ? parts.slice(1).join('.') : undefined

  if (!surname) {
    return {
      fullName: firstname,
      initials: firstname.charAt(0).toUpperCase(),
    }
  }

  return {
    fullName: `${firstname} ${surname}`,
    initials: `${firstname.charAt(0).toUpperCase()}${surname.charAt(0).toUpperCase()}`,
  }
}

export const getUsername = async (apiClient: ApiClient) => {
  const tokenStr = (await apiClient.getAccessToken()) || ''
  const tokenJwt = jwtDecode(tokenStr)
  return (tokenJwt as IToken).name
}

export const getFirstName = (name: string) => {
  if (!name) {
    return ''
  }

  const adhocName = name.split(' ')[0]
  if (adhocName.indexOf('.') === -1) {
    return adhocName
  }

  const firstname = adhocName.split('.')[0]

  return firstname.charAt(0).toUpperCase() + firstname.slice(1)
}
